export const selectRedirectLocation = ({ auth }) => auth.redirectLocation;
export const selectSignInParamValue = ({ auth }) => auth.signInParamValue;
